import { configureStore } from '@reduxjs/toolkit';
import themeReducer from 'src/features/theme/redux/theme-slice';
import clientsReducer from 'src/features/clients/redux/clients-slice';
import historyReducer from 'src/features/clients/redux/history-slice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        clients: clientsReducer,
        history: historyReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['reports/setFromDate', 'reports/setToDate'],
                // Ignore these paths in the state
                ignoredPaths: ['reports.fromDate', 'reports.toDate'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
